/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RankListResponseWrapper } from '../../models/rank-list-response-wrapper';

export interface GetChampionList$Params {
  month: string;
  nameSpace: string;
}

export function getChampionList(http: HttpClient, rootUrl: string, params: GetChampionList$Params, context?: HttpContext): Observable<StrictHttpResponse<RankListResponseWrapper>> {
  const rb = new RequestBuilder(rootUrl, getChampionList.PATH, 'get');
  if (params) {
    rb.query('month', params.month, {});
    rb.path('nameSpace', params.nameSpace, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RankListResponseWrapper>;
    })
  );
}

getChampionList.PATH = '/api/namespaces/{nameSpace}/championlist';
